module.exports = "/images/camera-line-top-left-bottom-right.svg?51d21477a4bdc2043d623b25122e4b96";